import React, { useEffect, useState } from "react";
import { Switch } from "@mantine/core";

import errorMsg from "Services/errorMsg";
import axiosClient from "Services/axiosClient";

import { areYouSureAlert, changedAlert } from "Components/Alerts/Alerts";

const ActiveBtn = ({ patch, state }) => {
  const [isChecked, setIsChecked] = useState(state);

  useEffect(() => {
    setIsChecked(state);
  }, [state]);

  const changedWithSuccess = () => setIsChecked((prevState) => !prevState);

  const changeState = () => {
    // dispatch(toggleRefresh());
    areYouSureAlert().then((result) => {
      if (result.isConfirmed) {
        const newState = { active: !state };

        axiosClient
          .patch(patch, newState)
          .then((res) => {
            changedAlert();
            changedWithSuccess();
          })
          .catch((error) => {
            console.error("Request failed:", error);
            errorMsg(error);
          });
      }
    });
  };

  return (
    <Switch
      onChange={changeState}
      checked={isChecked}
      defaultChecked
      color="blue"
    />
  );
};

export default ActiveBtn;
